import { render, staticRenderFns } from "./fusing.vue?vue&type=template&id=6c943a5d&scoped=true"
import script from "./fusing.vue?vue&type=script&lang=js"
export * from "./fusing.vue?vue&type=script&lang=js"
import style0 from "./fusing.vue?vue&type=style&index=0&id=6c943a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c943a5d",
  null
  
)

export default component.exports